import React, { useContext } from 'react';

import { SegmentedControl, Select } from '@imgly/imgly-website-components';
import classNames from 'classnames';

import { getUnifiedCodeLanguageId } from '../../../utils/getUnifiedCodeLanguageId';
import { ContentContext } from '../../context/ContentContext';
import { useResponsiveWidth } from '../../hooks/useResponsiveWidth';

import * as classes from './style.module.scss';

export const Settings: React.FC = () => {
  const { activeItems, displayedValues, handleSettingsClick } =
    useContext(ContentContext);
  const [ref, measuredRef, widerThanParent] = useResponsiveWidth();

  const handleChange = (value: string | number | null) => {
    if (typeof value === 'string') {
      handleSettingsClick(value, false);
    }
  };

  if (!displayedValues) {
    return null;
  }

  return (
    <div className={classes.root} ref={ref} data-testid="page-settings">
      <div
        className={classes.container}
        ref={measuredRef}
        style={{ display: widerThanParent ? 'none' : 'flex' }}
      >
        {displayedValues.map(
          ({ param, name, items }) =>
            Boolean(items.length) && (
              <SegmentedControl
                key={`segemented-control-${name}`}
                name={name}
                label={name}
                options={items.map(({ id, name: buttonName }) => ({
                  label: buttonName,
                  value: id,
                }))}
                disabled={items.length <= 1}
                value={activeItems[param]}
                onChange={handleChange}
              />
            ),
        )}
      </div>
      <div
        className={classNames(classes.container, classes.wrap)}
        ref={ref}
        style={{ display: widerThanParent ? 'flex' : 'none' }}
      >
        {displayedValues.map(
          ({ param, name, items }) =>
            Boolean(items.length) && (
              <div key={param} className={classes.param}>
                <span className={classes.label}>{name}:</span>
                <Select
                  aria-label={`Select the displayed ${name}`}
                  onChange={handleChange}
                  label={
                    items.find(
                      ({ id }) =>
                        getUnifiedCodeLanguageId(activeItems[param]) ===
                        getUnifiedCodeLanguageId(id),
                    )?.name || name
                  }
                  value={activeItems[param]}
                  options={items.map(({ id, name: label }) => ({
                    label,
                    value: id,
                  }))}
                />
              </div>
            ),
        )}
      </div>
    </div>
  );
};
